module.exports = "/images/bk.png?1e52e432921caf0fe7e37f389b40b86e";